import styles from './BtnLoadIndication.module.scss';

/**
 * Компонент для отображения индикатора загрузки
 * @returns 
 */
export const BtnLoadIndication = ({ isLoading }: { isLoading: boolean }) => {
    return isLoading && <div className={styles.loader}></div>;
};